// extracted by mini-css-extract-plugin
export default {"cls1":"VeloRadioTileGroup-Image_cls1__j+vSG","cls2":"VeloRadioTileGroup-Image_cls2__xf3E7 VeloRadioTileGroup-Image_cls1__j+vSG"};